import { CreditCard } from './CreditCard';

export const enabledCards = [
  'AAA_DAILY_ADVANTAGE_VISA_SIGNATURE',
  'AAA_TRAVEL_ADVANTAGE_VISA_SIGNATURE',
  'AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD',
  'ACTIVE_CASH_CARD',
  'AEROPLAN_CARD',
  'AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD',
  'AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD',
  'ALASKA_AIRLINES_BUSINESS_CREDIT_CARD',
  'ALLWAYS_REWARDS_VISA',
  'AMAZON_BUSINESS_CARD',
  'AMAZON_BUSINESS_PRIME_CARD',
  'AMAZON_VISA',
  'AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD',
  'AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD',
  'AMERICAN_EXPRESS_BLUE_CASH_PREFERRED_CARD',
  'AMERICAN_EXPRESS_GOLD_CARD',
  'AMERICAN_EXPRESS_GREEN_CARD',
  'AMERICAN_EXPRESS_THE_PLATINUM_CARD',
  'AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD',
  'APPLE_CARD',
  'ATHLETA_REWARDS_MASTERCARD',
  'ATTUNE_CARD',
  'ATT_POINTS_PLUS_CARD_FROM_CITI',
  'AUTOGRAPH_CARD',
  'AUTOGRAPH_JOURNEY_CARD',
  'A_A_R_P_ESSENTIAL_REWARDS_MASTERCARD_FROM_BARCLAYS',
  'A_A_R_P_TRAVEL_REWARDS_MASTERCARD_FROM_BARCLAYS',
  'BANANA_REPUBLIC_REWARDS_MASTERCARD',
  'BANKAMERICARD',
  'BANKAMERICARD_FOR_STUDENTS',
  'BANKAMERICARD_SECURED',
  'BANK_OF_AMERICA_ATMOS_REWARDS_ASCENT_VISA_SIGNATURE_CARD',
  'BANK_OF_AMERICA_ATMOS_REWARDS_SUMMIT_VISA_INFINITE_CREDIT_CARD',
  'BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS',
  'BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS',
  'BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED',
  'BANK_OF_AMERICA_PREMIUM_REWARDS',
  'BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE',
  'BANK_OF_AMERICA_TRAVEL_REWARDS',
  'BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS',
  'BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED',
  'BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS',
  'BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS',
  'BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED',
  'BARCLAYS_CARNIVAL_WORLD_MASTERCARD',
  'BARCLAYS_G_M_BUSINESS_MASTERCARD',
  'BARCLAYS_G_M_REWARDS_MASTERCARD',
  'BARCLAYS_JET_BLUE_PREMIER_CARD',
  'BARNES_NOBLE_MASTERCARD',
  'BILT_BLUE_CARD',
  'BILT_MASTERCARD',
  'BILT_OBSIDIAN_CARD',
  'BILT_PALLADIUM_CARD',
  'BLUE_BUSINESS_CASHTM_CARD',
  'BLUE_BUSINESS_PLUS_CREDIT_CARD',
  'BLUE_CASH_EVERYDAY_CARD_FROM_AMERICAN_EXPRESS_CARD',
  'BMO_CASH_BACK_MASTERCARD',
  'BREAD_REWARDS_AMERICAN_EXPRESS_CARD',
  'BREEZE_EASYVISA_CREDIT_CARD',
  'BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD',
  'BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD',
  'BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD',
  'BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD',
  'BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD',
  'BUSINESS_GOLD_CARD',
  'BUSINESS_GREEN_REWARDS_CARD',
  'BUSINESS_PLATINUM_CARD',
  'CAPITAL_ONE_SAVOR_ONE_REWARDS',
  'CAPITAL_ONE_WALMART_REWARDS_MASTERCARD',
  'CAPITAL_VACATIONSWORLD_MASTERCARD',
  'CELEBRITY_CRUISES_VISA_SIGNATURE',
  'CHASE_FREEDOM_FLEX_CREDIT_CARD',
  'CHASE_FREEDOM_RISE_CREDIT_CARD',
  'CHASE_FREEDOM_UNLIMITED_CREDIT_CARD',
  'CHASE_INSTACART_MASTERCARD',
  'CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD',
  'CHASE_SAPPHIRE_RESERVE_CREDIT_CARD',
  'CHASE_SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD',
  'CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD',
  // Removed: CHASE_UNITED_CLUB_BUSINESS_CARD (duplicate of UNITED_CLUB_BUSINESS_CARD)
  'CHOICE_PRIVILEGES_SELECT_MASTERCARD',
  'CITI_AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD',
  'CITI_AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD',
  'CITI_CUSTOM_CASH_CARD',
  'CITI_DIAMOND_PREFERRED_CREDIT_CARD',
  'CITI_DOUBLE_CASH_CARD',
  'CITI_MACYS_CREDIT_CARDS',
  'CITI_PRO_XTRA_CREDIT_CARD',
  'CITI_SECURED_MASTERCARD',
  'CITI_SIMPLICITY_CREDIT_CARD',
  'CITI_STRATA_CARD',
  'CITI_STRATA_ELITE_CARD',
  'CITI_STRATA_PREMIER_CARD',
  'COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI',
  'COSTCO_ANYWHERE_VISA_CARD_BY_CITI',
  'CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD',
  'DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD',
  'DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD',
  'DELTA_SKYMILES_GOLD_BUSINESS_CARD',
  'DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD',
  'DELTA_SKYMILES_PLATINUM_BUSINESS_CARD',
  'DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD',
  'DELTA_SKYMILES_RESERVE_BUSINESS_CARD',
  'DISCOVER_IT_CASH_BACK_CREDIT_CARD',
  'DISCOVER_IT_CHROME_GAS_RESTAURANT_CREDIT_CARD',
  'DISCOVER_IT_MILES_CREDIT_CARD',
  'DISCOVER_IT_SECURED_CREDIT_CARD',
  'DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD',
  'DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD',
  'DISNEY_PREMIER_VISA_CARD',
  'DISNEY_VISA_CARD',
  'DOORDASH_REWARDS_MASTERCARD',
  'EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD',
  'EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD',
  'FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD',
  'FRONTIER_AIRLINES_WORLD_MASTERCARD',
  'F_N_B_O_GREEN_SELECT_CREDIT_CARD',
  'GAP_GOOD_REWARDS_MASTERCARD',
  'GREENSTATE_CU_WORLD_MASTERCARD',
  'HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD',
  'HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD',
  'HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD',
  'HILTON_HONORS_AMERICAN_EXPRESS_CARD',
  'HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD',
  'HILTON_HONORS_BUSINESS_CARD',
  'HSBC_ELITE_CREDIT_CARD',
  'HSBC_PREMIER_CREDIT_CARD',
  'IBERIA_VISA_SIGNATURE_CREDIT_CARD',
  'IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD',
  'IHG_ONE_REWARDS_PREMIER_CREDIT_CARD',
  'IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD',
  'INK_BUSINESS_CASH_CREDIT_CARD',
  'INK_BUSINESS_PREFERRED_CREDIT_CARD',
  'INK_BUSINESS_PREMIER_CREDIT_CARD',
  'INK_BUSINESS_UNLIMITED_CREDIT_CARD',
  'JETBLUE_BUSINESS_CARD',
  'JETBLUE_CARD',
  'JETBLUE_PLUS_CARD',
  'LL_BEAN_MASTERCARD',
  'MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD',
  'MARRIOTT_BONVOY_BOLD_CREDIT_CARD',
  'MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD',
  'MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD',
  'MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD',
  'MARRIOTT_BONVOY_BUSINESS_CARD',
  'MILES_MOREWORLD_ELITE_MASTERCARD',
  'NASCAR_AMERICAN_EXPRESS_CARD',
  'NAVY_FEDERAL_FLAGSHIP_VISA_SIGNATURE',
  'NAVYIST_REWARDS_MASTERCARD',
  'NHL_DISCOVER_IT_CREDIT_CARD',
  'NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD',
  'ONE_KEY_CARD',
  'PENFED_PATHFINDER_REWARDS_VISA_SIGNATURE',
  'PLATINUM_MASTERCARD',
  'PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD',
  'PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE',
  'PLATINUM_SECURED',
  'PLUM_CARD',
  'PNC_CASH_REWARDS_VISA',
  'PRIME_VISA',
  'QUICKSILVERONE_REWARDS',
  'QUICKSILVER_REWARDS',
  'QUICKSILVER_REWARDS_FOR_GOOD_CREDIT',
  'QUICKSILVER_REWARDS_FOR_STUDENTS',
  'QUICKSILVER_SECURED_REWARDS',
  'RCIELITE_REWARDSWORLD_MASTERCARD',
  'REDSTONE_FCU_VISA_SIGNATURE',
  'REFLECT_CARD',
  'ROBINHOOD_CARD',
  'ROBINHOOD_PLATINUM_CARD',
  'ROYAL_CARIBBEAN_VISA_SIGNATURE',
  'SAMS_CLUB_CREDIT_CARD',
  'SAVOR_REWARDS',
  'SAVOR_REWARDS_FOR_GOOD_CREDIT',
  'SAVOR_REWARDS_FOR_STUDENTS',
  'SIGNIFY_BUSINESS_CARD',
  'SLATE_EDGE_CREDIT_CARD',
  'SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD',
  'SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD',
  'SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD',
  'SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD',
  'SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD',
  'SPARK_15X_MILES_SELECT',
  'SPARK_15_CASH_SELECT',
  'SPARK_2X_MILES',
  'SPARK_2_CASH',
  'SPARK_2_CASH_PLUS',
  'SPARK_CLASSIC',
  'SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS',
  'SYNCHRONY_OUTDOORS_CREDIT_CARD',
  'TD_DOUBLE_UP_CREDIT_CARD',
  'THE_HOME_DEPOT_CONSUMER_CREDIT_CARD',
  'UNITED_BUSINESS_CARD',
  'UNITED_CLUB_BUSINESS_CARD',
  'UNITED_CLUB_INFINITE_CARD',
  'UNITED_EXPLORER_CARD',
  'UNITED_GATEWAY_CREDIT_CARD',
  'UNITED_QUEST_CARD',
  'UPROMISEWORLD_MASTERCARD',
  'USAA_CASHBACK_REWARDS_PLUS',
  'US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD',
  'US_BANK_ALTITUDE_GO_SECURED_VISA_CARD',
  'US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD',
  'US_BANK_CASH_SECURED_VISA_CARD',
  'US_BANK_CASH_VISA_SIGNATURE_CARD',
  'US_BANK_SECURED_VISA_CARD',
  'US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD',
  'US_BANK_SMARTLY_VISA_SIGNATURE_CARD',
  'U_S_BANK_U_S_B_A_N_K_S_H_I_E_L_D_V_I_S_A_C_A_R_D',
  'VENMO_VISA_CREDIT_CARD',
  'VENTUREONE_REWARDS',
  'VENTUREONE_REWARDS_FOR_GOOD_CREDIT',
  'VENTURE_REWARDS',
  'VENTURE_X_BUSINESS',
  'VENTURE_X_REWARDS',
  'WORLD_OF_HYATT_BUSINESS_CREDIT_CARD',
  'WORLD_OF_HYATT_CREDIT_CARD',
  'WYNDHAM_REWARDS_EARNERCARD',
  'WYNDHAM_REWARDS_EARNER_BUSINESS_CARD',
  'WYNDHAM_REWARDS_EARNER_PLUS_CARD',
  'XBOX_MASTERCARD',
] as CreditCard[];
